module.exports = __webpack_public_path__ + "img/truck-ramp-couch.1f21e949.svg";